// Per-store third-party tracking ids (StoreConfig.analytics), edited by the
// merchant in prodpanel → Pengaturan and applied by the storefront's
// src/analytics.ts. Mirrors terbebas-backend src/service/analytics.service.ts —
// the id patterns below are duplicated there (separate repo, cannot import).
// Keep the two in sync.
//
// These are not secrets: they ship to every shopper's browser. They ARE
// format-checked on both ends because the storefront interpolates them into
// script URLs and inline JS.
export var ANALYTICS_VENDORS = [
    {
        key: 'metaPixel',
        idField: 'pixelId',
        label: 'Meta (Facebook) Pixel',
        hint: 'Events Manager → Data Sources → pilih piksel → ID Piksel (angka saja)',
        placeholder: '1234567890123456',
        pattern: /^\d{6,20}$/,
        upperCase: false,
    },
    {
        key: 'hotjar',
        idField: 'siteId',
        label: 'Hotjar',
        hint: 'Hotjar → Settings → Sites & Organizations → Site ID (angka saja)',
        placeholder: '3456789',
        pattern: /^\d{4,12}$/,
        upperCase: false,
    },
    {
        key: 'gtm',
        idField: 'containerId',
        label: 'Google Tag Manager',
        hint: 'GTM → Workspace → ID kontainer, format GTM-XXXXXXX',
        placeholder: 'GTM-ABC1234',
        pattern: /^GTM-[A-Z0-9]{4,10}$/,
        upperCase: true,
    },
    {
        key: 'ga4',
        idField: 'measurementId',
        label: 'Google Analytics 4',
        hint: 'GA4 → Admin → Data Streams → Measurement ID, format G-XXXXXXXXXX',
        placeholder: 'G-AB12CD34EF',
        pattern: /^G-[A-Z0-9]{6,15}$/,
        upperCase: true,
    },
    {
        key: 'clarity',
        idField: 'projectId',
        label: 'Microsoft Clarity',
        hint: 'Clarity → Settings → Overview → Project ID',
        placeholder: 'ab1cd2ef3g',
        pattern: /^[a-z0-9]{6,15}$/i,
        upperCase: false,
    },
];
// Reads a vendor's id out of the config, trimmed and case-normalized.
// Returns '' when the vendor is absent or has no id.
export function analyticsVendorId(config, spec) {
    var settings = config === null || config === void 0 ? void 0 : config[spec.key];
    var raw = settings === null || settings === void 0 ? void 0 : settings[spec.idField];
    var id = typeof raw === 'string' ? raw.trim() : '';
    return spec.upperCase ? id.toUpperCase() : id;
}
// True when the merchant switched this vendor on AND its id is well-formed.
// The storefront checks this again before building any script URL, so a bad
// row written before validation existed can never reach the DOM.
export function isAnalyticsVendorActive(config, spec) {
    var settings = config === null || config === void 0 ? void 0 : config[spec.key];
    if (!settings || !settings.enabled)
        return false;
    var id = analyticsVendorId(config, spec);
    return !!id && spec.pattern.test(id);
}
